export default function getEnvironmentName() {
  const parts = window.location.hostname.split(".");
  if (parts.length === 2) {
    return "production";
  }

  const env = parts[0];

  if (env === "dev") {
    return "development";
  }

  return env;
}
